import type { ServiceStatus } from '@/lib/schemas/db'

export interface ServiceStatusMeta {
  /** Tailwind background class for the status dot */
  dotClass: string
  /** Tailwind text class for the status label */
  textClass: string
}

const metaByStatus: Record<string, ServiceStatusMeta> = {
  New: { dotClass: 'bg-amber-500', textClass: 'text-amber-800' },
  NewJob: { dotClass: 'bg-amber-500', textClass: 'text-amber-800' },
  Booked: { dotClass: 'bg-blue-500', textClass: 'text-blue-700' },
  ReadyToWork: { dotClass: 'bg-amber-500', textClass: 'text-amber-700' },
  Arrived: { dotClass: 'bg-amber-500', textClass: 'text-amber-700' },
  LeftSite: { dotClass: 'bg-blue-500', textClass: 'text-blue-700' },
  Started: { dotClass: 'bg-blue-500', textClass: 'text-blue-700' },
  Ended: { dotClass: 'bg-blue-500', textClass: 'text-blue-700' },
  InProgress: { dotClass: 'bg-blue-500', textClass: 'text-blue-700' },
  Review: { dotClass: 'bg-indigo-500', textClass: 'text-indigo-700' },
  // Every blocking status reads the same red — the work is stopped either way,
  // and the label carries which kind of stall it is.
  Blocked: { dotClass: 'bg-rose-500', textClass: 'text-rose-700' },
  WaitingOnParts: { dotClass: 'bg-rose-500', textClass: 'text-rose-700' },
  ReadyForCollection: { dotClass: 'bg-teal-500', textClass: 'text-teal-700' },
  // Both collection outcomes read as "resolved" (green) so technicians see the
  // work as done; the Unsuccessful qualifier + reason carry the orange warning.
  ReadyForCollectionUnsuccessful: {
    dotClass: 'bg-teal-500',
    textClass: 'text-teal-700',
  },
  ReadyToInvoice: { dotClass: 'bg-emerald-500', textClass: 'text-emerald-700' },
  Invoiced: { dotClass: 'bg-emerald-500', textClass: 'text-emerald-700' },
  Cancelled: { dotClass: 'bg-slate-400', textClass: 'text-slate-500' },
}

const fallbackMeta: ServiceStatusMeta = {
  dotClass: 'bg-slate-400',
  textClass: 'text-slate-600',
}

export function getServiceStatusMeta(
  status: ServiceStatus | string,
): ServiceStatusMeta {
  return metaByStatus[status] ?? fallbackMeta
}
